import { ApiConfigServiceInterface, Tuple } from './types/ApiConfigTypes';

/**
 * * ApiConfigService
 * @description Service to set baseUrl and Tuples
 *
 * * @function getBaseUrl
 *   @returns string BaseURL
 *   @description to get baseURL
 * * @function setBaseUrl
 *   @param URL
 *   @type string
 *   @description: to set baseURL for API request
 * * @function getTuples
 *   @returns Object with headers
 *   @description  to get default tuples
 * * @function addTuple
 *   @param key (header key)
 *   @type string
 *   @param value (header value)
 *   @type string
 *   @description  to add single tuple
 * * @function setTuples
 *   @description  to add multiple tuples
 */
const ApiConfigService: ApiConfigServiceInterface = (function (root, factory) {
  let ApiConfigService: ApiConfigServiceInterface = {} as ApiConfigServiceInterface;
  if (root) {
    // If instance exists use it otherwise create new.
    if (root.ApiConfigService) {
      ({ ApiConfigService } = root);
    } else {
      root.ApiConfigService = ApiConfigService;
      return factory(ApiConfigService);
    }
  }

  return ApiConfigService;
})(
  (typeof window === 'object' && window) || (typeof globalThis === 'object' && globalThis) || this,
  function (ApiConfigService: ApiConfigServiceInterface) {
    let baseUrl = ''; // storage for baseURL
    let tuples: Tuple = {}; // storage for tuples
    // Methods for Base URL
    const getBaseUrl = () => baseUrl;
    const setBaseUrl = (url: string) => {
      baseUrl = url;
    };
    // Methods for Tuples
    const getTuples = () => tuples;
    const addTuple = (key: string, value: string) => {
      tuples[key] = value;
    };
    const setTuples = (tuplesObject: Tuple) => {
      tuples = tuplesObject;
    };

    // Adding methods to Instance.
    ApiConfigService.getBaseUrl = getBaseUrl;
    ApiConfigService.setBaseUrl = setBaseUrl;
    ApiConfigService.getTuples = getTuples;
    ApiConfigService.addTuple = addTuple;
    ApiConfigService.setTuples = setTuples;

    return ApiConfigService;
  },
);

export { ApiConfigService };
